import ConsignmentsTable from "./ConsignmentsTable";

export default ConsignmentsTable;
